export const uiSchema = t => {
  return {
    "ui:order": [
      "expiryPeriodInSeconds",
      "reminderTimeInSeconds",
      "reminderType",
      "copyInManagersManager",
      "lateReasonCapture",
      "*",
    ],
    expiryPeriodInSeconds: {
      "ui:widget": "seconds-as-hours-input",
      "ui:title": "Expiry Period In Hours",
      "ui:options": {
        editable: true,
      },
    },
    reminderTimeInSeconds: {
      "ui:widget": "seconds-as-hours-input",
      "ui:title": "Reminder Time In Hours",
      "ui:options": {
        editable: true,
      },
    },
    copyInManagersManager: {
      "ui:widget": "toggle",
    },
    lateReasonCapture: {
      "ui:widget": "toggle",
      "ui:options": {
        labels: [
          { label: t("CAPTURE_LATE_REAS"), value: true },
          { label: t("DO_NOT_CAPTURE"), value: false },
        ],
      },
    },
  };
};
